// its config for where the shown product and program dropdown in the app

export type ShowDropdownsType = {
  [page: string]: {
    [module: string]: {
      [subpage: string]: Array<"products" | "programs">
    }
  }
}
// all state of page, module and subpage manage explicitly
export const productAndProgramConfig: ShowDropdownsType = {
  // page module program
  truscore: {
    "practice-tests": {
      overview: ["products", "programs"],
      "skill-report": ["products", "programs"],
      "item-report": ["products", "programs"],
      "detail-report": ["products", "programs"],
      "scores-by-students-report": ["products", "programs"],
      "test-taking-report": ["products", "programs"],
      "threshold-report": ["products", "programs"],
      none: ["products", "programs"]
    },
    bubblesheets: {
      overview: ["products", "programs"],
      "skill-report": ["products", "programs"],
      "item-report": ["products", "programs"],
      "detail-report": ["products", "programs"],
      "scores-by-students-report": ["products", "programs"],
      "test-taking-report": ["products", "programs"],
      "threshold-report": ["products", "programs"],
      none: ["products", "programs"]
    },
    "study-hall": {
      lessons: ["products", "programs"],
      reports: ["products", "programs"],
      none: ["products", "programs"]
    }
  },
  mastery: {
    none: {
      none: ["products", "programs"]
    },
    resources: {
      lessons: ["products", "programs"],
      reports: ["products", "programs"],
      none: ["products", "programs"]
    }
  },
  profile: {
    none: {
      none: ["products", "programs"],
      whitelisting: ["products", "programs"]
    }
  },
  snap: {
    reports: {
      none: ["products", "programs"]
    },
    author: {
      none: ["products"]
    },
    student: {
      none: ["products", "programs"],
      act: ["products", "programs"],
      sat: ["products", "programs"],
      tsia2: ["products", "programs"]
    }
  },
  teacher: {
    elements: {
      none: ["products", "programs"],
      act: ["products", "programs"],
      actms: ["products", "programs"],
      sat: ["products", "programs"],
      tsia2: ["products", "programs"],
      dsat: ["products", "programs"]
    }
  },
  author: {
    none: {
      none: ["products"]
    }
  },
  ebooks: {
    none: {
      none: ["products", "programs"]
    }
  },
  manage: {
    organization: {
      districts: ["products"],
      "district-admins": ["products"],
      schools: ["products"],
      "school-admins": ["products"],
      teachers: ["products"],
      classes: ["products"],
      students: ["products"]
    },
    licenses: {
      districts: ["products"],
      "district-admins": ["products"],
      schools: ["products"],
      educators: ["products"],
      students: ["products"]
    },
    content: {
      manage: ["products"],
      sets: ["products"],
      "bubble-sheet-tests": ["products"],
      "knowledge-map": ["products"],
      author: ["products"],
      "mastery-lessons": ["products"]
    }
  },
  reports: {
    "usage-report": {
      none: ["products"]
    },
    "participation-report": {
      none: ["products"]
    },
    none: {
      none: ["products"]
    }
  },
  "school-support": {
    "test-administration": {
      "answer-document-upload": ["products", "programs"],
      none: ["products", "programs"]
    }
  },
  "context-help-manager": {
    none: {
      none: ["products"]
    }
  },
  help: {
    none: {
      none: ["products"]
    }
  },
  eoc: {
    none: {
      none: ["products", "programs"]
    },
    dashboard: {
      none: ["products", "programs"]
    },
    "study-plans": {
      none: ["products", "programs"],
      view: ["products", "programs"],
      edit: ["products", "programs"]
    },
    insights: {
      none: ["products", "programs"],
      mastery: ["products", "programs"],
      activity: ["products", "programs"],
      "scores-by-student": ["products", "programs"]
    }
  }
}
